import {
  SmartCollectionInput,
  SmartCollectionItem,
  SmartCollectionResponse,
} from '../types';
import { SMART_COLLECTION_EXCLUDED_NEEDS } from 'constants/segmentation';

/**
 * Type guard for SmartCollectionResponse
 */
export function isSmartCollectionResponse(
  input: unknown
): input is SmartCollectionResponse {
  return (
    input !== null &&
    typeof input === 'object' &&
    'items' in input &&
    Array.isArray(input.items)
  );
}

/**
 * Type guard for SmartCollectionResponse
 */
export function isSmartCollectionItem(
  input: unknown
): input is SmartCollectionItem {
  return (
    input !== null &&
    typeof input === 'object' &&
    'product_title' in input &&
    typeof input.product_title === 'string'
  );
}

export function cleanUpInput(
  input: SmartCollectionInput
): SmartCollectionInput {
  return {
    ...input,
    ...(input.needs
      ? {
          needs: input.needs.filter(
            (need) => !SMART_COLLECTION_EXCLUDED_NEEDS.includes(need)
          ),
        }
      : {}),
  };
}
